export default {
  Loans: {
    TITLE: 'Intercompany Balances',
    DETAILS: 'See transaction details',
    CONTACT_DETAILS: 'See full details',
    ERROR: 'Discrepancy',
    ERROR_AT: 'Discrepancy at {{date}}',
    ERROR_DESCRIPTION:
      'The discrepancy is the difference between the balances of the accounts in each entity',
    VIEW: 'View balances at',
    SHOWING: 'Showing balances at',
    FILTER: 'Quick filter',
    DISPLAY: 'Display type',
    CREDITOR: 'Creditor',
    CREDITOR_DESCRIPTION:
      'If no creditor is selected, whichever account has a positive (debit) balance will be classed as the creditor. For more information, head to our Help Centre.',
    DEBTOR: 'Debtor',
    BALANCE: 'Balance',
    BALANCE_AT: 'Balance at {{date}}',
    BALANCE_IN: 'Balance in {{account}}',
    CONTACT_AMOUNT_DUE: 'Amount due from Contact: {{contact}}',
    CONTACT_AMOUNT_OWED: 'Amount owed to Contact: {{contact}}',
    SPECIFIC_FX:
      'Using the FX rate entered into the accounting system:\n\n1 {{fromCurrency}} = {{rate}} {{toCurrency}}',
    CONTACT_NAME: 'Contact: {{contact}}',
    AMOUNT_DUE: 'Amount Due',
    INTEREST: 'Interest',
    NO_INTEREST: 'No Interest',
    LOAN_BALANCE: 'Balance',
    DISCREPANCY: 'Balance Discrepancy',
    DISCREPANCY_ALLOWANCE: 'Allow a discrepancy of',
    DISCREPANCY_TOOLTIP:
      'Balances will be coloured green if their discrepancy is less than this in their currency',
    OVERRIDDEN: 'This match was manually edited',
    FIX_MATCH: 'Fix this match',
    CREATE_JOURNAL: 'Create a journal in {{entity}}',
    CASH_IN_TRANSIT: 'Includes {{amount}} of cash in transit',
    DISCREPANCY_TRANSIT:
      'After taking into account {{amount}} of cash in transit',
    MONTH_DISCREPANCY:
      'The cumulative difference in amounts due for items in {{month}}',
    MONTH_AMOUNT_DUE:
      'The cumulative amounts due for items in {{entity}} in {{month}}',
    ITEMS_SUMMARY: ['{{count}} item', '{{count}} items'],
    SETTLED_ITEMS: ['{{count}} is settled', '{{count}} are settled'],
    BALANCED: 'In balance',
    UNBALANCED: 'Unbalanced',
    DISCREPANCIES: 'Discrepancies',
    FxPosting: {
      SYSTEM_ACCOUNT:
        "Due to restrictions in Xero's API, we cannot post as Posted to the {{code}} account.",
      ADD_MAPPING:
        'Please update the [Account Mappings](/groups/{{groupId}}/settings/account-mapping) to set the FX adjustment account',
      LINE_DESCRIPTION: 'FX Adjustment',
      NARRATIVE: 'FX Adjustment for Intercompany Balance with {{creditor}}',
    },
    Variance: {
      TOOLTIP:
        'Variance is how the discrepancy between balances changes with each line',
      VARIANCE: 'Variance',
    },
    Empty: {
      TITLE: 'No balance found',
      DESCRIPTION:
        "We couldn't find any balance between {{creditor}} and {{debtor}}. If there should be one, check the [account code mapping](/groups/{{groupId}}/settings/account-mapping) and re-sync.",
    },
    NoLoans: {
      TITLE: 'Balance missing',
      DESCRIPTION: "We couldn't find the balance you requested.",
    },
    NoTransactions: {
      TITLE: 'No transactions found',
      DESCRIPTION: "We couldn't find any transactions for this balance.",
    },
    ArApNoTransactions: {
      TITLE: 'No transactions found',
      DESCRIPTION:
        "We couldn't find any data for this balance before {{date}}. Use the date picker at the top to see data for a different date.",
    },
    Matrix: {
      BALANCE_IN: 'Balance in {{entity}}: {{balance}}',
      OPEN_DETAILS: 'Click to open the full balance details',
      RIGHT_TOTAL: "The sum of all balances in the row's entity",
      BOTTOM_TOTAL:
        'The sum of all balances for the column in the row entities, after FX conversion (if necessary) at {{date}}',
    },
    TransactionTypes: {
      loan: 'Payment',
      repayment: 'Repayment',
      fx_movement: 'FX Adjustment',
      interest: 'Interest',
      unknown: 'Unknown',
      conversionBalance: 'Conversion Balance',
      reversal: 'Reversal',
      recharge: 'Recharge',
      brag: 'BRAG',
      invoice: 'Invoice',
      bill: 'Bill',
      credit_note: 'Credit Note',
      credit_note_bill: 'Bill Credit Note',
      ar_overpayment: 'Sales Overpayment',
      ap_overpayment: 'Bill Overpayment',
      ar_prepayment: 'Sales Prepayment',
      ap_prepayment: 'Bill Prepayment',
    },
    UNKNOWN_DESC:
      'We could not match this transaction. It could be an adjustment, or perhaps it has not yet been reconciled in one of the entities.',
    Conversions: {
      AFTER: 'After FX conversion',
      CORRECTION: 'Add FX adjustment to {{borrower}}',
      DATE: 'Last FX adjustment posted on {{date}}',
      ADD_CORRECTION: 'Add FX adjustment at {{date}}',
      VIEW_CORRECTION: 'View details',
      UPDATE_CORRECTION: 'Update FX adjustment',
      NEEDS_UPDATE:
        'This excludes the {{amount}} already posted as an FX adjustment',
      POSTED_ON: 'FX Adjustment of {{amount}} posted on {{date}}',
      VOIDED: ' is now voided',
      LAST_ADJUSTMENT: 'Last FX adjustment was posted for {{date}}',
      RECONCILE: 'Reconcile missing transactions',
      LOCKED: 'to easily post your FX adjustments to Xero',
      Errors: {
        none: 'None',
        fx_movement: 'FX Movement',
        tx_missing: 'Missing Transaction(s)',
        unknown: 'Unknown',
      },
    },
    Interest: {
      EDIT: 'Edit interest setting',
      DELETE: 'Delete interest setting',
      CANNOT_DELETE: 'This interest setting cannot be deleted',
      INVOICE: 'Invoice {{borrower}} for interest',
      ADD: 'Add interest to balance',
      VIEW: 'View interest postings',
      UPDATE: 'Update interest postings',
      ADD_ACCOUNTS: 'Add interest to intercompany balances',
      POSTED_ON: 'Interest of {{amount}} posted as {{type}} on {{date}}',
      INVOICE_BILL: 'invoice and bill',
      JOURNALS: 'journals',
      LAST_POSTING: 'Interest was last charged for {{date}}',
      ADD_MAPPING:
        'Please update the [Account Mappings](/groups/{{groupId}}/settings/account-mapping) to set the interest accounts',
      NO_POSTING:
        "There have been no interest postings since the Group's start date on {{start}}. Interest in prior months could affect this calculation, so please check other months are correct before posting this",
      NO_RECENT_POSTING:
        'There have been no interest postings since {{date}}. Interest in prior months could affect this calculation, so please check other months are correct before posting this',
      LOCKED:
        'to easily calculate and post the interest due on your intercompany balances',
      Modal: {
        HEADING: 'Set Interest Rate',
        DATE: 'Date',
        RATE: 'Rate thereafter',
        RATE_INFO: 'The rate will be applied from the date specified.',
        Ranges: {
          NO_INTEREST: 'None',
          FIXED_RATE: 'Fixed Rate',
          VARIABLE: 'Interest',
        },
        Confirm: {
          NONE: 'Confirm no Interest',
          FIXED: 'Confirm Fixed Rate',
          VARIABLE: 'Confirm Variable Rate',
        },
      },
      LINE_DESCRIPTION: 'Interest',
      NARRATIVE: '{{date}} Interest for Intercompany Balance with {{entity}}',
      START_DATE:
        "This is the group's start date. We will apply interest from this date.",
    },
    Settings: {
      TITLE: 'Intercompany Balances Settings',
      EDIT: 'Edit balance',
      DELETE: 'Delete balance',
      Creditor: {
        ANY: 'Any entity can be a creditor',
        ANY_SUB:
          'Whichever account has a positive (debit) balance will be classed as the creditor',
        ORGS: 'The following entities are always creditors:',
        SETTING:
          'You can override the creditor for each balance from the balance configuration screen',
      },
      Currency: {
        LENDER: "Denominate balances in the creditor's currency",
        CUSTOM: 'Denominate balances in:',
      },
    },
    Edit: {
      CTA: 'Edit transaction matches',
      TITLE: 'Edit: {{name}}',
      SELECTED: [
        '{{count}} transaction selected',
        '{{count}} transactions selected',
      ],
      SPLIT: ['Separate Transaction', 'Separate Transactions'],
      TOGGLE_MATCH: 'Toggle the whole row',
      GROUP: 'Group Transactions...',
      CHANGE_TYPE: 'Change Type...',
      SAVE: 'Save Overrides',
      TYPE: 'What type of transaction was this?',
      NO_MATCH: 'No transactions match "{{search}}"',
      UNPERSISTED: "This override hasn't been saved yet",
    },
    Download: {
      TOOLTIP:
        'Print or Export as PDF via the print dialogue. Note: for large groups, increasing the page size to A0 or A1 may be preferable for readability.',
    },
    Filter: {
      ALL: 'All balances',
      ACCOUNT: 'Account-based balances',
      ARAP: 'AR/AP balances',
    },
    Notice: {
      EXTRA_LOANS:
        'You are only allowed a maximum of 3 intercompany balances on your current plan, but you currently have {{number}}.',
      CROSS_CURRENCY:
        'You are only allowed intercompany balances in the same currency on your current plan, but you currently have cross-currency balances.',
      DELETE: 'delete intercompany balances',
      WARNING: 'Warning',
    },
    FixMissing: {
      PARTNER_TRANSACTIONS: [
        '{{count}} Transaction in {{name}}',
        '{{count}} Transactions in {{name}}',
      ],
    },
    ARAP: {
      Warnings: {
        TOTALS: 'The total amounts do not match in these items',
        ONE_SIDED: 'An item should be present in both entities',
      },
      TOTALS: 'Totals as of {{date}}',
    },
  },
};
